import blog from "../../../../marketplace-commons/config/app/services/blog.json";
export { solveMessage } from "../../helpers/solveMessage";
export var getSearchConfig = function (country, enviroment) {
    if (enviroment === void 0) { enviroment = "production"; }
    var _a = blog[country][enviroment], base = _a.base, search = _a.search, fullResults = _a.fullResults;
    return {
        search: "" + base + search,
        fullResults: "" + base + fullResults,
    };
};
export var getSearchEndpoint = function (country, enviroment, searchTerm) {
    if (enviroment === void 0) { enviroment = "production"; }
    var search = getSearchConfig(country, enviroment).search;
    return "" + search + searchTerm;
};
//# sourceMappingURL=helpers.js.map